import { render, staticRenderFns } from "./TotalAbsencePerMonthReport.vue?vue&type=template&id=a1f5f60a"
import script from "./TotalAbsencePerMonthReport.vue?vue&type=script&lang=js"
export * from "./TotalAbsencePerMonthReport.vue?vue&type=script&lang=js"
import style0 from "./TotalAbsencePerMonthReport.vue?vue&type=style&index=0&id=a1f5f60a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports